import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export function registerHandlebarsHelpers(Handlebars) {
    Handlebars.registerHelper('since', function since(date) {
        const escapedDate = Handlebars.Utils.escapeExpression(date);

        return new Handlebars.SafeString(dayjs(escapedDate).fromNow());
    });

    Handlebars.registerHelper('num_format', function numFormat(num) {
        const escapedNum = Handlebars.Utils.escapeExpression(num);
        const formatted = escapedNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        return new Handlebars.SafeString(formatted);
    });
}
